import React from "react";
import Main from "./Main";
import PublishedBooks from "./publishedBooks/PublishedBooks";
import Footer from "./Footer";

const Home = () => {
  return (
    <div>
      <Main />
      <PublishedBooks/>
      <Footer/>
    </div>
  );
};

export default Home;
